export const ENV = [
  { label: 'Test', value: 'test' },
  // { label: 'Beta', value: 'beta' },
  { label: 'Production', value: 'prod' },
];
